<template lang="pug">
  .report
    .option3
      span {{ $wp('employee') }}
      PRadio(label="ativos", v-model="reportOptions.resignation", option="active")
      PRadio(label="demitidos", v-model="reportOptions.resignation", option="notActive")
      PRadio(label="que já registraram ponto", v-model="reportOptions.resignation", option="hasTimelogs")
      PRadio(label="todos", v-model="reportOptions.resignation", option="all")

    .option2
      PMultiSelect(v-model="reportOptions.fields" title="campos" labelItem="name")

    .button
      PButton(color="success" size="md" @click="generate" :loading="loading" :disabled="!valid") gerar excel

</template>

<script>
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    const data = {
      loading: false,
      reportOptions: {
        resignation: 'active',
        fields: {
          selected: [],
          loaded: [
            {name: 'PIN para registro de ponto', id: 'phoneclock_password'},
            {name: 'CPF', id: 'cpf'},
            {name: 'RG', id: 'rg'},
            {name: 'Escala', id: 'routine'},
            {name: 'Local de Trabalho', id: 'company'},
            {name: 'Data de admissão', id: 'admission'},
            {name: 'Data de demissão', id: 'resignation'},
            {name: 'Empregador', id: 'employer'},
            {name: 'Campos customizáveis', id: 'custom_fields'},
            {name: 'Campos customizáveis da folha', id: 'custom_fields_folha'},
            {name: 'Regras de Cálculo', id: 'custom_rules'},
            {name: 'Código', id: 'code'},
            {name: 'Departamento', id: 'department'},
            {name: 'Função', id: 'funct'},
            {name: 'Data de início da folha', id: 'closing_date'},
            {name: 'Telefone Celular', id: 'cell_phone'},
            {name: 'Telefone Residencial', id: 'phone'},
            {name: 'Banco de Horas', id: 'work_hour_bank_rules'},
            {name: 'Registra ponto em qualquer Local de Trabalho', id: 'phoneclock_all'},
            {name: 'Registrar Horário de Pausa Automaticamente', id: 'auto_pause_fill'},
            {name: 'CTPS', id: 'ctps'},
            {name: 'PIS', id: 'pis'},
            {name: 'Gravar ponto com voz no Aplicativo (Android)', id: 'allow_app_voice'},
            {name: 'Gravar ponto com foto no Aplicativo (Android)', id: 'allow_app_photo'},
            {name: 'Mostrar jornada no Aplicativo (Android)', id: 'allow_app_show_day_journey'},
            {name: 'Mostrar feedback no Aplicativo (Android)', id: 'allow_app_feedback'},
            {name: 'Gravar ponto com voz no PontoTel Web (Computador)', id: 'allow_web_voice'},
            {name: 'Ativar dupla confirmação de registro de ponto (Computador)', id: 'double_check_web'}
          ]
        }
      }
    }

    data.reportOptions.fields.selected = [...data.reportOptions.fields.loaded]

    return data
  },
  computed: {
    entity () {
      if (this.reportInfo.entity === 'employees') return 'employee'
      return this.reportInfo.entity
    }
  },
  methods: {
    async generate () {
      this.loading = true

      let result

      try {
        result = await this.$API.R13.save({
          entity: this.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          ...this.reportOptions,
          fields: this.reportOptions.fields.selected.map(i => i.id)
        })
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 30px;
  grid-template-columns: 1fr 1fr;

  .option {
    span {grid-column: 1/3}

    display: grid;
    grid-template-columns: max-content max-content;
    grid-column-gap: 30px;
  }

  .option2 {
    grid-column: 1/3;
    grid-row: 2/2;
  }

  .option3 {
    span {grid-column: 1/5}

    display: grid;
    grid-template-columns: max-content max-content max-content;
    grid-column-gap: 30px;
  }

  .button {
    grid-column: 1/3;
    grid-row: 3/3;
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
